@use 'src/global/variables.scss' as var;

:host {
  border-radius: 100vh;
  box-shadow: var.$message-screen-elements-box-shadow;
}
svg {
  width: 3.4rem;
  height: 3.4rem;
}
